export const pricingSectionCopy = {
  title: 'Choose your perfect plan',
  subtitle:
    'Select a plan that best fits your business needs. All plans include core features with different levels of access and support.',
  noHiddenFees: 'No hidden fees.',
  noHiddenFeesDetail: 'Everything is a flat monthly rate.',
};

export const pricingPackages = [
  {
    id: 'solo',
    name: 'Solo',
    monthlyPrice: 20,
    yearlyPrice: 192,
    description: 'Perfect for individuals running their business on their own.',
    isPopular: false,
    features: [
      { id: '1', name: 'Unlimited Appointments', included: true },
      { id: '2', name: '1 Employee (owner only)', included: true },
      { id: '3', name: 'Email notifications', included: true },
      { id: '4', name: 'Customer management', included: true },
      { id: '5', name: 'SMS Notifications', included: true },
      { id: '6', name: 'Ticketing System Support', included: true },
    ],
    buttonText: 'Get Started',
  },
  {
    id: 'business',
    name: 'Business',
    monthlyPrice: 40,
    yearlyPrice: 384,
    description: 'Perfect for small businesses just getting started with scheduling.',
    isPopular: false,
    features: [
      { id: '1', name: 'Unlimited Appointments', included: true },
      { id: '2', name: '5 Employees', included: true },
      { id: '3', name: 'Email notifications', included: true },
      { id: '4', name: 'Customer management', included: true },
      { id: '5', name: 'SMS Notifications', included: true },
      { id: '6', name: 'Ticketing System Support', included: true },
    ],
    buttonText: 'Get Started',
  },
  {
    id: 'business_plus',
    name: 'Business Plus',
    monthlyPrice: 80,
    yearlyPrice: 768,
    description: 'Ideal for growing businesses needing more features and support.',
    isPopular: true,
    features: [
      { id: '1', name: '25 Employees', included: true },
      { id: '2', name: 'Advanced calendar integration', included: true },
      { id: '3', name: 'SMS notifications', included: true },
      { id: '4', name: 'Customer management', included: true },
      { id: '5', name: 'Priority support', included: true },
    ],
    buttonText: 'Get Started',
  },
  {
    id: 'custom',
    name: 'Custom',
    monthlyPrice: 0,
    yearlyPrice: 0,
    description: 'Tailored solutions for larger teams and unique requirements.',
    isPopular: false,
    contactOnly: true,
    features: [
      { id: '1', name: 'Unlimited Employees', included: true },
      { id: '2', name: 'Phone support', included: true },
      { id: '3', name: 'Dedicated account manager', included: true },
      { id: '4', name: 'Custom development (quoted separately)', included: true },
    ],
    buttonText: 'Contact Us',
  },
];

/** Limits used during account setup checkout */
export const pricingPackageLimits = {
  solo: { employees: 1, appointments: -1 },
  business: { employees: 5, appointments: -1 },
  business_plus: { employees: 25, appointments: -1 },
  custom: { employees: -1, appointments: -1 },
  enterprise: { employees: -1, appointments: -1 },
  free_trial: { employees: 500, appointments: -1 },
};
